import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';
import { IconCollapseSolid, IconFullScreenSolid } from '@roku-web-ui/rds-icons';
import { useSearch } from '@tanstack/react-router';

import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';

interface FullscreenProps {
  isFullscreen: boolean;
  disabled?: boolean;
  toggleFullscreen: () => void;
}

export const Fullscreen = ({ isFullscreen, disabled = false, toggleFullscreen }: FullscreenProps) => {
  const { eventId } = useSearch({ from: '/events' });
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip
      title={disabled ? 'Video is being processed' : `${isFullscreen ? 'Exit' : 'Enter'} fullscreen`}
      placement="top"
    >
      <IconButton
        aria-label="fullscreen"
        data-testid="button-fullscreen"
        disabled={disabled}
        onClick={() => {
          if (disabled) return;

          if (eventId) {
            logAspenEvent({
              log_id: 'iot.web.event.interaction',
              payload: {
                event_id: eventId,
                interaction: 'fullscreen',
              },
            });
          }

          toggleFullscreen();
        }}
        sx={{
          '&.MuiIconButton-root': {
            padding: '0', // Override RDS padding
          },
          '&:disabled': {
            opacity: 0.5,
          },
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {isFullscreen ? (
          <IconCollapseSolid sx={{ color: colors.grey[400] }} />
        ) : (
          <IconFullScreenSolid sx={{ color: colors.grey[400] }} />
        )}
      </IconButton>
    </Tooltip>
  );
};
